const sessionKey = 'pageviews',
    showOnCount = 2;

function getPageViewCount() {
    const count = sessionStorage.getItem(sessionKey);

    return count !== null ? +count : 0;
}

function setPageViewCount(count) {
    sessionStorage.setItem(sessionKey, count);
}

export function isAnonymousCustomer() {
    return smartPak && smartPak.cdProfileCookie ? (!smartPak.cdProfileCookie.ExistingCustomer && !smartPak.cdProfileCookie.HasPassword) : false;
}

export function isAllowedURL(url) {
    const blacklist = [
        'horse-supplement-wizard',
        'utm_source=email-promotional',
        'utm_source=email-lifecycle',
        'login',
        'register',
        'cart'
    ];

    return !(new RegExp(blacklist.map(str => escapeForRegex(str)).join('|'), 'gi').test(url));
}

export default function spree() {
    if (!sessionStorage || !isAnonymousCustomer() || !isAllowedURL(location.href) || !!smartPak.cookie.read('QRCode')) {
        return;
    }

    let pageviews = getPageViewCount();

    setPageViewCount(pageviews + 1);

    if (pageviews === showOnCount) {
        import('./spreeform').then(({ default: spreeForm }) => spreeForm());
        return;
    }
}

function escapeForRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}


